import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * event
 * @event sendCallbackOk
 */
export function DrawDeliveryModalController () {
    this.busModal = mitt();
    this.callbackClose = null;
    this.callbackOk = null;
    this.drawDeliveryModel = null;
    this.title = '';
    this.btnOk = '';

    //#region setter
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setDrawDelivery = function (drawDeliveryModel) {
        this.drawDeliveryModel = drawDeliveryModel;
        return this;
    };
    this.setBtnOk = function(btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.clearModal = function () {
        this.drawDeliveryModel = null;
        this.callbackClose = null;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            drawDeliveryModel: this.drawDeliveryModel,
            title: this.title,
            btnOk: this.btnOk
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClose = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackClose = callback;
        }
    },
    this.sendCallbackClose = function(data) {
        if (Util.isFunction(this.callbackClose)) {
            this.callbackClose(data);
        }
    };
    this.onClickOk = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    };
    this.sendCallbackOk = function(data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    };

    //#endregion event
}
